import { useEffect } from "react";
import {
  supabaseServiceKey,
  loadConfig,
} from "../../../../components/env";

/**
 * Ensures backend env / Supabase client config is loaded for the standalone popup flow.
 */
export function SupabaseBootstrapEffect() {
  useEffect(() => {
    (async () => {
      console.log(
        "🎤 [EXTERNAL-PAGE] Loading Supabase config for external window...",
      );
      try {
        await loadConfig();
        console.log("🎤 [EXTERNAL-PAGE] Supabase config loaded successfully");
        console.log(
          "🎤 [EXTERNAL-PAGE] supabaseServiceKey available:",
          !!supabaseServiceKey,
        );
      } catch (err) {
        console.warn("⚠️ Could not load Supabase config:", err.message);
      }
    })();
  }, []);

  return null;
}
